import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'utils/I18n';
import SvgActionsLockClosedNormalXsmall from '@strava/icons/ActionsLockClosedNormalXsmall';
import SvgNavigationGroupNormalXsmall from '@strava/icons/NavigationGroupNormalXsmall';
import styles from './index.scss';
import { useFeedEntityContext } from '../FeedEntityContext';
import useFeedAnalytics from '../../../hooks/useFeedAnalytics';
import useFeedIntersectionObserver from '../../../hooks/useFeedIntersectionObserver';

const VisibilityMessage = ({ visibility }) => {
  const { inView, intersectionObserverRef } = useFeedIntersectionObserver({
    isParentFeedEntry: false
  });

  const { analyticProps } = useFeedEntityContext();
  useFeedAnalytics({
    ...analyticProps,
    element: 'privacy_banner',
    inView
  });

  let icon;
  let message;
  if (visibility === 'only_me') {
    icon = (
      <span data-testid="lock">
        <SvgActionsLockClosedNormalXsmall />
      </span>
    );
    message = (
      <span data-testid="only_me_text">
        {I18n.t('components.feed.module.private_activity_not_visible_html')}
      </span>
    );
  } else {
    icon = (
      <span data-testid="group">
        <SvgNavigationGroupNormalXsmall />
      </span>
    );
    message = (
      <span data-testid="group_text">
        {I18n.t('components.feed.module.followers_activity_not_visible_html')}
      </span>
    );
  }
  return (
    <div
      className={`${styles.visibilitySection}`}
      data-testid="visibility_section"
      ref={intersectionObserverRef}
    >
      <div className={`${styles.appIconWrapper} ${styles.iconWrapper}`}>
        <div className={`${styles.visibilityIcon}`}>{icon}</div>
      </div>
      {message}
    </div>
  );
};

VisibilityMessage.propTypes = {
  visibility: PropTypes.string.isRequired
};

export default VisibilityMessage;
